import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useHistory } from 'react-router-dom';
import {
    Grid,
    IconButton,
    Link,
    Typography,
    Table,
    TableBody,
    TableContainer,
    TableCell,
    TableHead,
    TableRow,
    Paper,
    Box,
    CircularProgress,
    Tooltip
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { toggleShowDialog } from '../../store/actions/dialog';
import { getVendasCanceladas } from '../../store/actions/vendas';
import TituloPagina from '../../components/layout/TituloPagina';
import moedaBr from '../../assets/js/moedaBr';
import formatarDataHora from '../../assets/js/formatarDataHora';
import DataTableComponent from '../../components/form/DataTableComponent';
import DialogAlert from '../../components/layout/DialogAlert';
import DialogFullScreen from '../../components/layout/DialogFullScreen';
import normalizarTitulo from '../../assets/js/normalizarTitulo';

const VendasCanceladas = props => {
    const history = useHistory();
    const {
        vendas,
        idDialogShow,
        usuario,
        getVendasCanceladas,
        negocioDoUsuario,
        loading
    } = props;
    const [toggleInformacoesUsuarioDialog, setToggleInformacoesUsuarioDialog] = useState(false);
    const [toggleDetalhesDaVendaDialog, setToggleDetalhesDaVendaDialog] = useState(false);

    const columns = [
        {
            name: 'Pedido Global',
            selector: (row) => row.pedidoId,
            center: 'true',
            sortable: true,
            width: '150px'
        },
        {
            name: 'Meu Pedido',
            selector: (row) => row.subPedidoId,
            center: 'true',
            sortable: true,
            width: '150px'
        },
        {
            name: 'Data/Hora',
            selector: (row) => row.instantePedido,
            sortable: true,
        },
        {
            name: 'Total do Pedido',
            selector: (row) => moedaBr(row.valorTotalBruto - row.valorTotalDesconto),
            sortable: true,
            width: '150px'
        },
        {
            name: 'Forma Pgto',
            selector: (row) => row.metodoPagamento === 'CARD' ? 'Cartão de Crédito' : normalizarTitulo(row.metodoPagamento),
            sortable: true,
            width: '200px'
        },
        {
            name: 'Status Pgto',
            selector: (row) => row.statusPagamento,
            sortable: true,
            width: '150px'
        },
        {
            name: 'Status Entrega',
            selector: (row) => row.statusEntrega,
            sortable: true,
            width: '200px'
        },
        {
            name: 'Ações',
            center: 'true',
            cell: (row) => (
                <Tooltip title='Detalhar Pedido' placement='right'>
                    <IconButton style={{ padding: 1 }} aria-label="visualizar" size='small' color='secondary' onClick={() => handleDetalhesDaVenda(row.subPedidoId)}><SearchIcon /></IconButton>
                </Tooltip>
            ),
            width: '100px'
        }
    ];

    useEffect(() => {
        getVendasCanceladas(negocioDoUsuario);
    }, [getVendasCanceladas, negocioDoUsuario]);

    const handleDetalhesDaVenda = (id) => {
        history.push({
            pathname: '/detalhar-venda',
            state: {
                pedidoVendedorId: id,
                from: window.location.pathname,
            },
        });
    }

    const handleTelefonesUsuario = (telefones) => {
        return telefones && telefones.map(telefone => telefone);
    }

    const handleListarProdutosPedido = (produtos) => {
        return produtos && produtos.map(produto => {
            const { variacoes } = produto;
            return variacoes.map(v => {
                let precoTotalSemDesconto = v.quantidade * v.precoUnitarioProduto;
                let precoTotal = v.precoTotalProduto;
                let desconto = (precoTotalSemDesconto - precoTotal) / precoTotalSemDesconto;
                return (
                    <TableRow key={v.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell component="th" scope="row" align='center'>{produto.idProduto}</TableCell>
                        <TableCell align="left">{`${produto.nomeProduto} `}
                            {v.codigoTamanho > 1 ? `${v.tamanho}/` : null}
                            {v.codigoEstampa > 1 ? `${v.estampa}/` : null}
                            {v.codigoCor > 1 ? v.cor : null}<br />
                            <strong>{v.estadoPedidoProduto}</strong> em {formatarDataHora(v.instanteEstado)}
                        </TableCell>
                        <TableCell align="center">{produto.unidadeMedida}</TableCell>
                        <TableCell align="center">{v.quantidade}</TableCell>
                        <TableCell align="right">{moedaBr(v.precoUnitarioProduto)}</TableCell>
                        <TableCell align="right">{moedaBr(v.precoTotalProduto)}</TableCell>
                        <TableCell align="right">{desconto}%</TableCell>
                    </TableRow>
                )
            })
        })
    }

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, height: '70vh' }}>
                <CircularProgress size={48} />
            </Box>
        );
    }

    return (
        <>
            <TituloPagina titulo='Vendas Canceladas' subtitulo={new Date().toLocaleString('pt-BR')} />
            <Box sx={{ height: '70vh' }}>
                <DataTableComponent
                    columns={columns}
                    data={vendas}
                />
            </Box>
            <DialogAlert title='Informações de Usuário'
                fullWidth={true}
                maxWidth='sm'
                cancelButtonClick={() => setToggleInformacoesUsuarioDialog(false)}
                labelCancelButton='Fechar'
                cancelButton={true}
                openDialog={toggleInformacoesUsuarioDialog}
            >
                <Grid container item style={{ paddingTop: '15px' }}>
                    <Grid item xs >
                        <Typography variant="subtitle1" style={{ color: '#999997' }}>Nome</Typography>
                        <Typography variant="body1" >{usuario.nome} {usuario.sobreNome}</Typography>
                        <Typography variant="subtitle1" style={{ color: '#999997' }} >Sexo</Typography>
                        <Typography variant="body1" >{usuario.sexo || '-'}</Typography>
                        <Typography variant="subtitle1" style={{ color: '#999997' }} >Data de Nascimento</Typography>
                        <Typography variant="body1" >{usuario.dataNascimento || '-'}</Typography>
                        <Typography variant="subtitle1" style={{ color: '#999997' }} >E-mail</Typography>
                        <Typography variant="body1" >{usuario.email}</Typography>
                        <Typography variant="subtitle1" style={{ color: '#999997' }} >Telefones</Typography>
                        <Typography variant="body1" >{handleTelefonesUsuario(usuario.telefones)}</Typography>
                        <Typography variant="subtitle1" style={{ color: '#999997' }} >Endereço para entrega</Typography>
                        <Typography variant="body1" ></Typography>
                    </Grid>
                </Grid>
            </DialogAlert>

            <DialogFullScreen title={`Pedido Nº ${idDialogShow.idPedido}`}
                cancelButtonClick={() => setToggleDetalhesDaVendaDialog(false)}
                labelCancelButton='Fechar'
                cancelButton={true}
                onButton={false}
                openDialog={toggleDetalhesDaVendaDialog}
            >
                <Grid container item style={{ marginTop: 65 }}>
                    <Grid item xs={6}>
                        <Typography variant="subtitle1" style={{ color: '#999997' }}>Data/Hora do Pedido</Typography>
                        <Typography variant="body1" >{formatarDataHora(idDialogShow.instantePedido)}</Typography>
                        <Typography variant="subtitle1" style={{ color: '#999997' }} >Valor Total do Pedido</Typography>
                        <Typography variant="body1" >{moedaBr(idDialogShow.valorTotalBruto)}</Typography>
                        <Typography variant="subtitle1" style={{ color: '#999997' }} >Usuário</Typography>
                        <Typography variant="body1" >{idDialogShow.idUsuario} {idDialogShow.nomeCompletoUsuario}</Typography>
                        <Typography variant="subtitle1" style={{ color: '#999997' }} >Endereço de Entrega</Typography>
                        <Typography variant="body1" >{idDialogShow.enderecoParaEntrega}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="subtitle1" style={{ color: '#999997' }} >Forma de Pagamento</Typography>
                        <Typography variant="body1" >{idDialogShow.formaPagamento}</Typography>
                        <Typography variant="subtitle1" style={{ color: '#999997' }} >Cupom de Desconto</Typography>
                        <Typography variant="body1" >{idDialogShow.cupomDesconto !== "" ? idDialogShow.cupomDesconto : 'Não'}</Typography>
                    </Grid>
                </Grid>
                <Grid container item style={{ marginTop: 15 }}>
                    <Grid item xs >
                        <Typography variant="h6" align='center'>Produtos do Pedido</Typography>
                    </Grid>
                </Grid>
                <TableContainer component={Paper} style={{ marginTop: 15 }}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead style={{ backgroundColor: '#ccc' }}>
                            <TableRow>
                                <TableCell align="center" width={50} style={{ fontWeight: 'bold' }}>ID</TableCell>
                                <TableCell align="left" style={{ fontWeight: 'bold' }}>Produto</TableCell>
                                <TableCell align="center" width={50} style={{ fontWeight: 'bold' }}>Unidade</TableCell>
                                <TableCell align="center" width={150} style={{ fontWeight: 'bold' }}>Quantidade</TableCell>
                                <TableCell align="right" width={150} style={{ fontWeight: 'bold' }}>Preço Unitário</TableCell>
                                <TableCell align="right" width={150} style={{ fontWeight: 'bold' }}>Preço Total</TableCell>
                                <TableCell align="right" width={150} style={{ fontWeight: 'bold' }}>Desconto</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {handleListarProdutosPedido(idDialogShow.produtos)}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogFullScreen>
        </>
    )
}

const mapStateToProps = state => (
    {
        vendas: state.venda.vendas,
        usuario: state.usuario.usuario,
        idDialogShow: state.dialog.idDialogShow,
        venda: state.venda.venda,
        loading: state.venda.loading,
        negocioDoUsuario: state.negocio.negocioDoUsuario
    });

const mapDispatchToProps = dispatch => bindActionCreators({
    toggleShowDialog,
    getVendasCanceladas,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(VendasCanceladas);